// The fields of a capture as bucketws sees one.
//
// datum's equivalent (projects/datum-repoflow/common/schema/capture/fields.js)
// has to describe a capture written against ANY point, so its dimensions and
// measures are open `{name, value}` arrays. bucketws knows exactly which point
// these came from — the bucket-size point, written by its own handlers — so it
// can name the columns and give them types. That is the whole difference
// between the two files, and the reason the listing here sorts and formats
// properly where datum's renders text.

export const captureId = {
  // It is the fileId. `captureId` is datum's name for the column, and this is
  // the only place the two vocabularies meet — the label is what a bucket owner
  // is actually looking at.
  label: "File Id",
  type: "string",
};

export const eventType = {
  label: "Event",
  type: "string",
};

export const timestamp = {
  label: "Timestamp",
  type: "string",
};

export const ext = {
  label: "Ext",
  type: "string",
};

// Every measure below is a DELTA and may be negative: the remove handler writes
// the file's sizes negated, which is what lets datum's aggregate sum a window
// into a net change. A schema that declared these `minimum: 0` would be
// describing a different system.
export const size = {
  label: "Size",
  type: "integer",
};

export const totalSize = {
  label: "Total Size",
  type: "integer",
};

export const derivedFileSize = {
  label: "Derived Size",
  type: "integer",
};

export const derivedFileCount = {
  label: "Derived Files",
  type: "integer",
};

// The faithful shapes, for /Public/Capture. Same reasoning as datum's
// `namedValue`: a measure's type is decided by the point rather than the
// capture, so `value` stays a union here and nothing renders it directly.
const namedValue = {
  type: "object",
  properties: {
    name: {
      type: "string",
      minLength: 1,
    },
    value: {
      type: ["string", "number", "boolean"],
    },
  },
  required: ["name", "value"],
};

export const dimensions = {
  label: "Dimensions",
  type: "array",
  items: namedValue,
  default: [],
  widget: "list",
};

export const measures = {
  label: "Measures",
  type: "array",
  items: namedValue,
  default: [],
  widget: "list",
};
